import React, { useState } from 'react';
import styled from 'styled-components';
import SkillButton from './SkillSetting';

const SelectView = ({ indexNum }) => {
    const [hasFilter, setHasFilter] = useState(true); // 초기에 필터를 적용합니다.

    const ContainerWrapper = styled.div``;

    const Container = styled.div`
        border-radius: 20px;
        border: 1px solid #c1c1c1;

        width: ${window.innerHeight / 2.2}px;
        height: ${window.innerHeight / 1.3}px;
        background-color: white;

        overflow: hidden;
    `;

    const ScreenImage = styled.img`
        width: 100%;
        height: 60%;
        object-fit: cover;

        transition: filter 0.3s ease; /* 필터 변화를 부드럽게 만들기 위한 transition 추가 */
    `;

    const ContentContainer = styled.div`
        padding-left: 4%;
        padding-right: 4%;
    `;

    const SkillContainer = styled.div`
        display: flex;
        align-items: center; /* 세로 가운데 정렬 */
    `;

    const DetailText = styled.div`
        position: absolute;
        margin-top: -40px;
        margin-left: 10px;
    `;
    const TextParagraph = styled.div`
        overflow: hidden;
        white-space: normal;
        font-size: 14px;
        margin-bottom: 3%;
    `;

    const getImageAndText = (indexNum) => {
        switch (indexNum) {
            case 0:
                return {
                    imageUrl: 'images/ScreenImage.png',
                    title: '내 손안의 작은 일정앱, 투두마이펫 📱',
                    description:
                        '투두리스트를 완료하면 "다마고치" 형식으로 나만의 펫을 성장시키며 사용자의 투두 사용을 유도합니다. 피드/마이페이지/달력 등의 여러 기능을 포함하고 있습니다.',
                    skillButtons: [
                        { content: 'React-Native', colorset: '#61DAFB' },
                        { content: 'React-Query', colorset: '#FF4154' },
                        { content: 'Zustand', colorset: '#ED9A01' },
                        { content: 'Axios', colorset: '#4F25E0' },
                    ],
                };
            case 1:
                return {
                    imageUrl: 'images/FairyTeller.png',
                    title: 'AI 동화제작 서비스, 페어리텔러 🖥️',
                    description:
                        '챗 GPT를 사용하여 시나리오를 자동으로 제작하거나 사용자가 직접 시나리오를 제작하여 그에 맞는 그림을 AI생성해 줍니다. 이미지와 시나리오를 합쳐 하나의 동화를 만들 수 있는 서비스 이며, 핵심기능인 동화 만들기, 게시판, 동화 읽어주는 TTS 기능이 포함되어 있습니다. ',
                    skillButtons: [
                        { content: 'React', colorset: '#61DAFB' },
                        { content: 'Recoile', colorset: '#2D6DE1' },
                        { content: 'Style-Component', colorset: '#DDA2DB' },
                        { content: 'Fabric.js', colorset: '#1E99D9' },
                        { content: 'Axios', colorset: '#4F25E0' },
                    ],
                };
            case 2:
                return {
                    imageUrl: 'images/DaJoba.png',
                    title: '면접 시선 교정 서비스, 다잡아 🖥️',
                    description:
                        '사용자의 동공을 추적하여 면접 시, 시선을 교정하는 서비스 입니다. 시선교정, 군소리 측정, 마이페이지 기능이 포함되어있습니다.',
                    skillButtons: [
                        { content: 'REACT', colorset: '#61DAFB' },
                        { content: 'React-Query', colorset: '#FF4154' },
                        { content: 'Recoile', colorset: '#ED9A01' },
                    ],
                };
            case 3:
                return {
                    imageUrl: 'images/GatherTomrow.png',
                    title: '분리배출 가이드, 내일을 모으다 📱',
                    description:
                        '카메라를 통한 물체탐지를 이용하여 올라른 배출 방법에 대한 가이드를 제공하는 서비스 입니다. 배출 가이드를 조회하면 포인트가 쌓여 운세를 볼 수 있고 해당 서비스를 이용해 분리배출을 유도하는 프로세스 입니다. ',
                    skillButtons: [
                        { content: 'React-Native', colorset: '#61DAFB' },
                        { content: 'Style-Component', colorset: '#DDA2DB' },
                        { content: 'Camera-Tflite', colorset: '#E64E3D' },
                    ],
                };
            case 4:
                return {
                    imageUrl: 'images/study.png',
                    title: '스터디',
                    description: '진행한 스터디/스터디 프로젝트를 정리한 차트 입니다.',
                    skillButtons: [
                        { content: 'JS', colorset: '#EED31A' },
                        { content: 'PINTOS', colorset: '#227F50' },
                        { content: 'NETWORK', colorset: '#61DAFB' },
                        { content: 'Operating System', colorset: '#000000' },
                    ],
                };
            default:
                return {
                    imageUrl: '',
                    title: '',
                    description: '',
                    skillButtons: [],
                };
        }
    };

    const { imageUrl, title, description, skillButtons } = getImageAndText(indexNum);

    return (
        <ContainerWrapper style={{ marginLeft: '1%', marginRight: '1%' }}>
            <Container onClick={() => console.log('Container 클릭됨', indexNum)}>
                <ScreenImage
                    alt="ScreenImage"
                    src={imageUrl}
                    hasFilter={hasFilter} // 필터 상태를 전달합니다.
                />
                <ContentContainer>
                    <h5 style={{ color: 'black', marginTop: '5%' }}>{title}</h5>
                    <TextParagraph style={{ color: 'black' }}>{description}</TextParagraph>
                    <SkillContainer style={{ overflowX: 'scroll' }}>
                        {skillButtons.map((button, index) => (
                            <SkillButton key={index} content={button.content} colorset={button.colorset} />
                        ))}
                    </SkillContainer>
                </ContentContainer>
            </Container>
            <DetailText>→ 자세히 보기 </DetailText>
        </ContainerWrapper>
    );
};

export default SelectView;
